import { useSelector } from 'react-redux';
import { CatTableCell } from '@blocks-react/components/TableCell';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { getSavedListTableSchema } from '../../constants';

const TableLineLoader = () => {
  const isCSPCustomer = useSelector(state => state?.common?.isCSPCustomer);
  const isInstantAccess = useSelector(state => state?.common?.isInstantAccess);

  const tableLineLoader = getSavedListTableSchema(isInstantAccess).map(item => (
    <CatTableCell key={item.id}>
      <CatSkeleton size="sm" />
    </CatTableCell>
  ));

  return (
    <>
      {tableLineLoader}
      {isCSPCustomer && (
        <CatTableCell>
          <CatSkeleton size="sm" />
        </CatTableCell>
      )}
    </>
  );
};

export default TableLineLoader;
